<template>
  <div class="w-100">
    <v-btn
      data-tourid="rever-ai-button"
      class="navigation-ai-button"
      :width="mini ? '35px' : '100%'"
      height="35px"
      :icon="mini"
      rounded
      small
      outlined
      @click="$emit('click')"
    >
      <v-icon size="15" color="blue-grey lighten-1 pa-0 ma-0"
        >mdi-creation-outline</v-icon
      >
      <span v-if="!mini" class="white--text font-weight-medium ml-3 body-2"
        >{{ $t('menu.rever_ai') }}
      </span>
      <v-icon
        v-if="!mini"
        size="15"
        color="blue-grey lighten-1"
        class="ml-3 pa-0"
        >mdi-message</v-icon
      >
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'ReverAIButtonNavigationDrawer',

  props: {
    mini: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.navigation-ai-button {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  color: white;
  cursor: pointer;
  background: linear-gradient($color-blue-darken2 0 0) padding-box,
    // This is the filling color.
      conic-gradient(
        from 180deg at 50% 50%,
        #b3d3ff 0deg,
        #3882f0 152.05deg,
        #b3d3ff 360deg
      )
      border-box;
  padding-top: 9px;
  padding-bottom: 9px;
  border: 2px solid transparent;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
}
</style>
